import { render } from "./metric-target.vue?vue&type=template&id=ba72672a&scoped=true"
import script from "./metric-target.vue?vue&type=script&lang=js"
export * from "./metric-target.vue?vue&type=script&lang=js"

import "./metric-target.vue?vue&type=style&index=0&id=ba72672a&lang=scss&scoped=true"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba72672a"]])

export default __exports__